export default __webpack_public_path__ + "static/media/healthCare.b2471998.jpg";